import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, createBlock as _createBlock, vShow as _vShow, createSlots as _createSlots, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "col-12 p-3 card align-items-center" }
const _hoisted_2 = { class: "d-flex mx-2 py-2 px-3 pb-2" }
const _hoisted_3 = { class: "form-group col-3 col-md-4 pe-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, " Patient ", -1 /* HOISTED */)
const _hoisted_5 = { class: "form-group d-flex pe-4" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "form-group d-flex align-self-end" }
const _hoisted_8 = {
  key: 0,
  class: "form-group d-flex ms-auto"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary align-self-end dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, " New Referral ", -1 /* HOISTED */)
const _hoisted_10 = { class: "dropdown-menu" }
const _hoisted_11 = {
  key: 1,
  class: "form-group d-flex ms-auto"
}
const _hoisted_12 = {
  key: 1,
  type: "button",
  class: "btn btn-primary align-self-end dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_13 = { class: "dropdown-menu" }
const _hoisted_14 = { class: "mx-2 mt-2" }
const _hoisted_15 = { class: "table table-responsive-md border border-gray" }
const _hoisted_16 = { class: "bg-table-header" }
const _hoisted_17 = { class: "align-middle" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Patient Information")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" MRN ")
const _hoisted_21 = { class: "align-middle" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Address ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" DOB")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Gender ")
const _hoisted_26 = { class: "align-middle" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Status ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" SOC")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_30 = /*#__PURE__*/_createTextVNode("D/C ")
const _hoisted_31 = { class: "align-middle" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Service Line ")
const _hoisted_33 = { class: "align-middle" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Branch ")
const _hoisted_35 = /*#__PURE__*/_createElementVNode("th", { class: "text-end align-middle" }, "Actions", -1 /* HOISTED */)
const _hoisted_36 = {
  key: 0,
  class: "table-empty"
}
const _hoisted_37 = ["colspan"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h3", null, "No Patients Found.", -1 /* HOISTED */)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 1,
  class: "table-error"
}
const _hoisted_41 = ["colspan"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "col-12 row g-0 p-3 px-4" }
const _hoisted_45 = { class: "form-group col-3 offset-lg-1 mb-0 me-3" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { for: "branch" }, [
  /*#__PURE__*/_createTextVNode(" Branch "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: "null" }, "Select Branch", -1 /* HOISTED */)
const _hoisted_48 = ["value"]
const _hoisted_49 = ["label", "value"]
const _hoisted_50 = ["value"]
const _hoisted_51 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_52 = { class: "form-group col-3 mb-0 me-3" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { for: "firstName" }, [
  /*#__PURE__*/_createTextVNode(" First Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_56 = { class: "form-group col-3 mb-0 me-3" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, [
  /*#__PURE__*/_createTextVNode(" Last Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_58 = ["disabled"]
const _hoisted_59 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_60 = {
  key: 0,
  class: "col-12 row g-0 p-2 px-4"
}
const _hoisted_61 = { class: "form-group col-3 offset-lg-1 mb-0 me-3 pb-3" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { for: "lineOfService" }, [
  /*#__PURE__*/_createTextVNode(" Line of Service "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Line of Service", -1 /* HOISTED */)
const _hoisted_64 = ["value"]
const _hoisted_65 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_66 = {
  key: 1,
  class: "p-5 d-flex flex-column items-center text-center text-primary"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x me-2 animated slow flash infinite" })
], -1 /* HOISTED */)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "big-text mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Save Referral In Progress...")
], -1 /* HOISTED */)
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = { class: "col-12 text-center pb-2 mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BranchDefaultFilter = _resolveComponent("BranchDefaultFilter")!
  const _component_SortableTh = _resolveComponent("SortableTh")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_CreateInterimReferralRow = _resolveComponent("CreateInterimReferralRow")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _component_PageLayout = _resolveComponent("PageLayout")!

  return (_openBlock(), _createBlock(_component_PageLayout, {
    "content-class": "p-0",
    "has-page-scroll": true
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.isLineOfServiceFormRequested)
          ? (_openBlock(), _createBlock(_component_FormSection, {
              key: 0,
              title: "Add Referral",
              fullHeight: false,
              class: "card-body p-2"
            }, _createSlots({ _: 2 /* DYNAMIC */ }, [
              (!_ctx.isAddingReferralLoading)
                ? {
                    name: "content",
                    fn: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _hoisted_4,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchPatientTerm) = $event)),
                            placeholder: "Search by patient name or MRN"
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, _ctx.searchPatientTerm]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("button", {
                            class: "btn btn-primary align-self-end",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search())),
                            disabled: !_ctx.searchPatientTerm || _ctx.isSearchLoading
                          }, " Search ", 8 /* PROPS */, _hoisted_6)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_BranchDefaultFilter, {
                            checkAllByDefault: true,
                            "selected-branches": _ctx.selectedBranches,
                            onUpdateBranches: _ctx.updateBranches,
                            "is-referral": true
                          }, null, 8 /* PROPS */, ["selected-branches", "onUpdateBranches"])
                        ]),
                        (_ctx.showNewReferral)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (!_ctx.inquiry)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _hoisted_9,
                                    _createElementVNode("div", _hoisted_10, [
                                      (
                                                (_ctx.hasInquiryId &&
                                                    _ctx.inquiryApplication == _ctx.hospiceApplicationId &&
                                                    _ctx.checkProductPermission.showNewReferralHospice) ||
                                                (!_ctx.hasInquiryId &&
                                                    _ctx.checkProductPermission &&
                                                    _ctx.agencyApplicationList.includes(_ctx.hospiceApplicationId))
                                            )
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "dropdown-item",
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openLineOfService(_ctx.hospiceApplicationId)))
                                          }, "Axxess Hospice"))
                                        : _createCommentVNode("v-if", true),
                                      (
                                                (_ctx.hasInquiryId &&
                                                    _ctx.inquiryApplication == _ctx.palliativeApplicationId &&
                                                    _ctx.checkProductPermission.showNewReferralHospice) ||
                                                (!_ctx.hasInquiryId &&
                                                    _ctx.checkProductPermission &&
                                                    _ctx.agencyApplicationList.includes(_ctx.palliativeApplicationId))
                                            )
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 1,
                                            class: "dropdown-item",
                                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openLineOfService(_ctx.palliativeApplicationId)))
                                          }, "Axxess Palliative Care"))
                                        : _createCommentVNode("v-if", true),
                                      (
                                                (_ctx.hasInquiryId &&
                                                    _ctx.inquiryApplication == _ctx.homeHealthApplicationId &&
                                                    _ctx.checkProductPermission.showNewReferralHospice) ||
                                                (!_ctx.hasInquiryId &&
                                                    _ctx.checkProductPermission &&
                                                    _ctx.agencyApplicationList.includes(_ctx.homeHealthApplicationId))
                                            )
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 2,
                                            class: "dropdown-item",
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openLineOfService(_ctx.homeHealthApplicationId)))
                                          }, "Axxess Home Health"))
                                        : _createCommentVNode("v-if", true),
                                      (
                                                (_ctx.hasInquiryId &&
                                                    _ctx.inquiryApplication == _ctx.homeCareApplicationId &&
                                                    _ctx.checkProductPermission.showNewReferralHospice) ||
                                                (!_ctx.hasInquiryId &&
                                                    _ctx.checkProductPermission &&
                                                    _ctx.agencyApplicationList.includes(_ctx.homeCareApplicationId))
                                            )
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 3,
                                            class: "dropdown-item",
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openLineOfService(_ctx.homeCareApplicationId, false)))
                                          }, "Axxess Home Care (Medical)"))
                                        : _createCommentVNode("v-if", true),
                                      (
                                                (_ctx.hasInquiryId &&
                                                    _ctx.inquiryApplication == _ctx.homeCareApplicationId &&
                                                    _ctx.checkProductPermission.showNewReferralHospice) ||
                                                (!_ctx.hasInquiryId &&
                                                    _ctx.checkProductPermission &&
                                                    _ctx.agencyApplicationList.includes(_ctx.homeCareApplicationId))
                                            )
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 4,
                                            class: "dropdown-item",
                                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openLineOfService(_ctx.homeCareApplicationId, true)))
                                          }, "Axxess Home Care (Non-Medical)"))
                                        : _createCommentVNode("v-if", true)
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    (_ctx.currentApplication != _ctx.homeCareApplicationId)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "btn btn-primary align-self-end",
                                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openLineOfService(_ctx.currentApplication)))
                                        }, " New Patient "))
                                      : (_openBlock(), _createElementBlock("button", _hoisted_12, " New Patient ")),
                                    _createElementVNode("div", _hoisted_13, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openLineOfService(_ctx.homeCareApplicationId, false)))
                                      }, "Medical"),
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openLineOfService(_ctx.homeCareApplicationId, true)))
                                      }, "Non-Medical")
                                    ])
                                  ]))
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_Pagination, {
                          ref: "patientListPagination",
                          entity: "Patients",
                          classes: "pagination-footer",
                          isLoading: _ctx.isSearchLoading,
                          pageSize: _ctx.pageSize,
                          showPageSizeOptions: true,
                          pageChanged: _ctx.pageChangedCallback,
                          onUpdatePageSizeChanged: _ctx.updatePageSizeChanged
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("table", _hoisted_15, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", _hoisted_16, [
                                  _createElementVNode("th", _hoisted_17, [
                                    _createVNode(_component_SortableTh, {
                                      "sort-by": _ctx.sortBy,
                                      onSortByUpdated: _ctx.sortByUpdated,
                                      "sort-order": _ctx.sortOrder,
                                      onSortOrderUpdated: _ctx.sortOrderUpdated,
                                      "sort-string": "patientName"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_18,
                                        _hoisted_19,
                                        _hoisted_20
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                                  ]),
                                  _createElementVNode("th", _hoisted_21, [
                                    _createVNode(_component_SortableTh, {
                                      "sort-by": _ctx.sortBy,
                                      onSortByUpdated: _ctx.sortByUpdated,
                                      "sort-order": _ctx.sortOrder,
                                      onSortOrderUpdated: _ctx.sortOrderUpdated,
                                      "sort-string": "primaryAddress"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_22
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                                  ]),
                                  _createElementVNode("th", null, [
                                    _createVNode(_component_SortableTh, {
                                      "sort-by": _ctx.sortBy,
                                      onSortByUpdated: _ctx.sortByUpdated,
                                      "sort-order": _ctx.sortOrder,
                                      onSortOrderUpdated: _ctx.sortOrderUpdated,
                                      "sort-string": "dateOfBirth"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_23,
                                        _hoisted_24,
                                        _hoisted_25
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                                  ]),
                                  _createElementVNode("th", _hoisted_26, [
                                    _createVNode(_component_SortableTh, {
                                      "sort-by": _ctx.sortBy,
                                      onSortByUpdated: _ctx.sortByUpdated,
                                      "sort-order": _ctx.sortOrder,
                                      onSortOrderUpdated: _ctx.sortOrderUpdated,
                                      "sort-string": "status"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_27
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                                  ]),
                                  _createElementVNode("th", null, [
                                    _createVNode(_component_SortableTh, {
                                      "sort-by": _ctx.sortBy,
                                      onSortByUpdated: _ctx.sortByUpdated,
                                      "sort-order": _ctx.sortOrder,
                                      onSortOrderUpdated: _ctx.sortOrderUpdated,
                                      "sort-string": "startOfCare"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_28,
                                        _hoisted_29,
                                        _hoisted_30
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                                  ]),
                                  _createElementVNode("th", _hoisted_31, [
                                    _createVNode(_component_SortableTh, {
                                      "sort-by": _ctx.sortBy,
                                      onSortByUpdated: _ctx.sortByUpdated,
                                      "sort-order": _ctx.sortOrder,
                                      onSortOrderUpdated: _ctx.sortOrderUpdated,
                                      "sort-string": "serviceLine"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_32
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                                  ]),
                                  _createElementVNode("th", _hoisted_33, [
                                    _createVNode(_component_SortableTh, {
                                      "sort-by": _ctx.sortBy,
                                      onSortByUpdated: _ctx.sortByUpdated,
                                      "sort-order": _ctx.sortOrder,
                                      onSortOrderUpdated: _ctx.sortOrderUpdated,
                                      "sort-string": "branchName"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_34
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                                  ]),
                                  _hoisted_35
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                _createCommentVNode(" EMPTY "),
                                (!_ctx.isSearchLoading && !_ctx.isSearchError && !_ctx.hasData)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                                      _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_39, 8 /* PROPS */, _hoisted_37)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                _createCommentVNode(" ERROR "),
                                (!_ctx.isSearchLoading && _ctx.isSearchError)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                                      _createElementVNode("td", { colspan: _ctx.columns }, [
                                        _createVNode(_component_ErrorMessageHandler, {
                                          title: "Patients",
                                          "try-again": _ctx.search
                                        }, null, 8 /* PROPS */, ["try-again"])
                                      ], 8 /* PROPS */, _hoisted_41)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                _createCommentVNode(" LOADING "),
                                (_ctx.isSearchLoading)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, _renderList(3, (i) => {
                                      return _createElementVNode("tr", {
                                        class: "table-loading",
                                        key: i
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                                          return (_openBlock(), _createElementBlock("td", { key: i }, _hoisted_43))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ])
                                    }), 64 /* STABLE_FRAGMENT */))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("tbody", null, [
                                (!_ctx.isSearchLoading)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.page?.items, (patient) => {
                                      return (_openBlock(), _createBlock(_component_CreateInterimReferralRow, {
                                        key: patient.id,
                                        agencyServices: _ctx.agencyService,
                                        agencyList: _ctx.agencyApplicationList,
                                        patient: patient,
                                        checkProductPermission: _ctx.checkProductPermission,
                                        hasDocViewPermission: _ctx.hasDocViewPermission,
                                        handleConvertToPending: _ctx.handleConvertToPending
                                      }, null, 8 /* PROPS */, ["agencyServices", "agencyList", "patient", "checkProductPermission", "hasDocViewPermission", "handleConvertToPending"]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  : _createCommentVNode("v-if", true)
                              ])
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["isLoading", "pageSize", "pageChanged", "onUpdatePageSizeChanged"])
                      ], 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.showPatientList]
                      ])
                    ])
                  }
                : undefined
            ]), 1024 /* DYNAMIC_SLOTS */))
          : (_openBlock(), _createBlock(_component_FormSection, {
              key: 1,
              title: "New Patient Referral",
              fullHeight: false,
              class: "card-body p-2",
              applicationId: _ctx.lineOfService.application
            }, _createSlots({ _: 2 /* DYNAMIC */ }, [
              (!_ctx.isAddingReferralLoading)
                ? {
                    name: "content",
                    fn: _withCtx(() => [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedBranch) = $event)),
                            onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.v$.selectedBranch.id.$touch && _ctx.v$.selectedBranch.id.$touch(...args)))
                          }, [
                            _hoisted_47,
                            (_ctx.providerList.length === 1)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.providerList[0].branches, (branch) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: branch,
                                    key: branch
                                  }, _toDisplayString(branch.name), 9 /* TEXT, PROPS */, _hoisted_48))
                                }), 128 /* KEYED_FRAGMENT */))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.providerList, (provider) => {
                                  return (_openBlock(), _createElementBlock("optgroup", {
                                    label: provider.name,
                                    value: provider,
                                    key: provider.name
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provider.branches, (branch) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: branch.name,
                                        value: branch
                                      }, _toDisplayString(branch.name), 9 /* TEXT, PROPS */, _hoisted_50))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ], 8 /* PROPS */, _hoisted_49))
                                }), 128 /* KEYED_FRAGMENT */))
                          ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                            [_vModelSelect, _ctx.selectedBranch]
                          ]),
                          (_ctx.isFieldInvalid('branch'))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, "Branch is required."))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _hoisted_53,
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control",
                            name: "firstName",
                            type: "text",
                            placeholder: "Enter First Name",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.lineOfService.firstName) = $event)),
                            onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.v$.lineOfService.firstName.$touch && _ctx.v$.lineOfService.firstName.$touch(...args))),
                            maxlength: "35",
                            disabled: _ctx.isConvertBackToPending
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_54), [
                            [_vModelText, _ctx.lineOfService.firstName]
                          ]),
                          (_ctx.v$.lineOfService.firstName.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_55, "First name is required."))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _hoisted_57,
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control",
                            name: "lastName",
                            type: "text",
                            placeholder: "Enter Last Name",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.lineOfService.lastName) = $event)),
                            onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.v$.lineOfService.lastName.$touch && _ctx.v$.lineOfService.lastName.$touch(...args))),
                            maxlength: "50",
                            disabled: _ctx.isConvertBackToPending
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_58), [
                            [_vModelText, _ctx.lineOfService.lastName]
                          ]),
                          (_ctx.v$.lineOfService.lastName.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_59, "Last name is required."))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]),
                      (_ctx.isApplicationHospice)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              _withDirectives(_createElementVNode("select", {
                                class: "form-select",
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedPrimaryLineOfService) = $event)),
                                disabled: "",
                                onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.v$.selectedPrimaryLineOfService.$touch && _ctx.v$.selectedPrimaryLineOfService.$touch(...args)))
                              }, [
                                _hoisted_63,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.primaryLineOfServiceList, (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: option,
                                    key: option
                                  }, _toDisplayString(_ctx.lineOfServiceEnumMap.enum[option]), 9 /* TEXT, PROPS */, _hoisted_64))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                [_vModelSelect, _ctx.selectedPrimaryLineOfService]
                              ]),
                              (_ctx.isFieldInvalid('selectedPrimaryLineOfService'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_65, "Line of service is required."))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (_ctx.isAddingReferralLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, _hoisted_69))
                        : _createCommentVNode("v-if", true)
                    ])
                  }
                : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["applicationId"]))
      ]),
      _createElementVNode("div", _hoisted_70, [
        (_ctx.isLineOfServiceFormRequested && !_ctx.isAddingReferralLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("button", {
                class: "btn btn-primary me-2",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.addReferralForSelectedPatient()))
              }, "Add Referral"),
              _createElementVNode("button", {
                class: "btn btn-outline-primary",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.closeLineOfService()))
              }, "Cancel")
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        (!_ctx.isLineOfServiceFormRequested && !_ctx.isAddingReferralLoading)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-outline-primary",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.cancel()))
            }, " Cancel "))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }))
}